import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryService } from "../services/query-service";
import { QueryKeys } from "../config/query-keys";

export function useChangeConversationName() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      conversationId,
      newName,
    }: {
      conversationId: string;
      newName: string;
    }) => queryService.changeConversationName(conversationId, newName),

    onSuccess: (_, variables) => {
      // Conversations listesini invalidate et - yeni isimle refresh olsun
      queryClient.invalidateQueries({
        queryKey: QueryKeys.CONVERSATIONS.list,
      });

      // Infinite query cache'ini optimistic update yap
      queryClient.setQueriesData(
        { queryKey: QueryKeys.CONVERSATIONS.list },
        (old: any) => {
          if (!old?.pages) return old;

          return {
            ...old,
            pages: old.pages.map((page: any) => ({
              ...page,
              data: {
                ...page.data,
                result: page.data.result.map((conversation: any) =>
                  conversation._id === variables.conversationId
                    ? { ...conversation, name: variables.newName }
                    : conversation
                ),
              },
            })),
          };
        }
      );
    },

    onError: (error) => {
      console.error("Failed to change conversation name:", error);
    },
  });
}
